<section class="carousel-wrapper" #carouselWrapper>
  <div class="carousel-inner" #carousel>
    <div
      *ngFor="let item of items; let i = index"
      (click)="itemSelected.next(i)"
      class="carousel-item"
      [style.width.px]="itemSizePx"
    >
      <div
        *ngIf="item.fileType === PostFileMediaType.Image"
        class="carousel-item-image"
        [style.background-image]="item.image"
        [style.height.px]="itemSizePx"
      ></div>
      <div
        *ngIf="item.fileType === PostFileMediaType.Video"
        class="carousel-item-video"
        [style.height.px]="itemSizePx"
      >
        <video src="{{ item.videoUrl }}"></video>
      </div>
    </div>
  </div>

  <div *ngIf="showControls && items?.length > numVisibleItems" class="buttons">
    <button
      (click)="prev()"
      class="button button-prev"
      *ngIf="currentSlide !== 0"
      [style.width.px]="buttonSizePx"
      [style.height.px]="buttonSizePx"
    >
      <mat-icon [style.fontSize.px]="buttonSizePx * 0.9">chevron_left</mat-icon>
    </button>
    <button
      (click)="next()"
      class="button button-next"
      *ngIf="currentSlide + numVisibleItems < items.length"
      [style.width.px]="buttonSizePx"
      [style.height.px]="buttonSizePx"
    >
      <mat-icon [style.fontSize.px]="buttonSizePx * 0.9"
        >chevron_right</mat-icon
      >
    </button>
  </div>
</section>
